class DarkrimProductSlider extends HTMLElement {
  connectedCallback() {
    this.slideshow = this.querySelector('slideshow-component');
    this.progress = this.querySelector('[data-darkrim-progress]');
    this.progressFill = this.querySelector('[data-darkrim-progress-fill]');
    this.previousButton = this.querySelector('[data-darkrim-previous]');
    this.nextButton = this.querySelector('[data-darkrim-next]');
    this.total = Number(this.dataset.slideCount) || 0;

    this.addEventListener('slideshow:select', this.handleSlideSelect);
    this.addEventListener('shopify:block:select', this.handleBlockSelect);
    this.updateProgress(0);
  }

  disconnectedCallback() {
    this.removeEventListener('slideshow:select', this.handleSlideSelect);
    this.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  handleSlideSelect = (event) => {
    if (!this.slideshow?.contains(event.detail.slide)) return;
    this.updateProgress(event.detail.index);
  };

  // Keep the carousel aligned with the block selected in Shopify's Theme Editor.
  handleBlockSelect = (event) => {
    if (!(event.target instanceof Element)) return;

    const slide = event.target.closest('slideshow-slide');
    const slides = Array.from(this.slideshow?.querySelectorAll('slideshow-slide') || []);
    const index = slides.indexOf(slide);

    if (index >= 0) this.slideshow?.select(index, undefined, { animate: false });
  };

  updateProgress(index) {
    if (!this.total || !this.progress || !this.progressFill) return;

    const current = Math.min(Math.max(index + 1, 1), this.total);
    const percentage = (current / this.total) * 100;

    this.progressFill.style.setProperty('--darkrim-prod-progress', `${percentage}%`);
    this.progress.setAttribute('aria-valuenow', String(current));
    this.progress.setAttribute('aria-valuetext', `${current} / ${this.total}`);

    if (this.previousButton) this.previousButton.disabled = current === 1;
    if (this.nextButton) this.nextButton.disabled = current === this.total;
  }
}

if (!customElements.get('darkrim-product-slider')) {
  customElements.define('darkrim-product-slider', DarkrimProductSlider);
}
